export const API_BASE = import.meta.env.VITE_API_BASE ?? '/api';
export const WS_BATTLE_URL =
  import.meta.env.VITE_WS_BATTLE_URL ??
  `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/ws/battle`;

export const TELEGRAM_BOT_USERNAME =
  import.meta.env.VITE_TELEGRAM_BOT_USERNAME ?? 'TaNkBAttle20260701_bot';

export const TELEGRAM_MINI_APP_SHORT_NAME =
  import.meta.env.VITE_TELEGRAM_MINI_APP_SHORT_NAME ?? '';

export function getTelegramInitData(): string {
  return window.Telegram?.WebApp?.initData ?? '';
}

const DEV_PLAYER_KEY = 'tank-battle-dev-player';

function getDevPlayerId(): string {
  let id = sessionStorage.getItem(DEV_PLAYER_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(DEV_PLAYER_KEY, id);
  }
  return id;
}

export function getApiHeaders(): Record<string, string> {
  const headers: Record<string, string> = {};
  const initData = getTelegramInitData();
  if (initData) {
    headers['X-Telegram-Init-Data'] = initData;
  } else {
    headers['X-Dev-Player-Id'] = getDevPlayerId();
  }
  return headers;
}
